import {ColumnsType} from "antd/lib/table";
import {TagDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {AsyncButtonPopconfirm, CrudTable, nameof} from "digimuth-components/dist";
import {Button, Popconfirm} from "antd";

export default function TagsList(props: TagListProps) {
    const columns: ColumnsType<TagDto> = [
        {
            title: "Nazwa",
            key: nameof<TagDto>("value"),
            dataIndex: nameof<TagDto>("value"),
        },
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            addButtonTitle={"+ Dodaj nowy tag"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń Całkowicie"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle={"Anuluj"}
            customActions={() => <Button onClick={props.onAddExistingClicked} type={"primary"}>+ Dodaj istniejące tagi</Button>}
            customRowActions={(row: TagDto) => <AsyncButtonPopconfirm danger okText={"Ok"}
                                                                      title={"Czy na pewno chcesz usunąć ten tag z produktu?"}
                                                                      onConfirm={() => props.onDeleteFromProductClicked(row)}>Usuń
                z produktu</AsyncButtonPopconfirm>}
        />
    </>
}

interface TagListProps extends CrudTableWrapperProps<TagDto> {
    allTags: TagDto[] | null
    onDeleteFromProductClicked: (tag: TagDto) => any;
    onAddExistingClicked: any;
}